import type { InputGroupAddonPassThroughOptions } from "primevue/inputgroupaddon";

export const inputgroupaddon: InputGroupAddonPassThroughOptions = {
  root: () => {
    return {
      class: [
        // layout
        "flex items-center justify-center h-8",
        //spacing
        "p-2",
        //font
        "text-body-lg",
        //color
        "text-system-grey bg-white",
        //border
        "border-[1px] border-surface-300 dark:border-surface-600 rounded-r-md"
      ]
    };
  }
};
